import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FishTabset, FishTab, FishTabContent, FishTabTitle, FishTabChangeEvent } from './tabset';
import { FishTabsetConfig } from './tabset-config';

export { FishTabset, FishTab, FishTabContent, FishTabTitle, FishTabChangeEvent } from './tabset';
export { FishTabsetConfig } from './tabset-config';

const FISH_TABSET_DIRECTIVES = [FishTabset, FishTab, FishTabContent, FishTabTitle];


export class FishTabsetModule {
  static forRoot(): ModuleWithProviders { return { ngModule: FishTabsetModule, providers: [FishTabsetConfig] }; }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{ declarations: FISH_TABSET_DIRECTIVES, exports: FISH_TABSET_DIRECTIVES, imports: [CommonModule] }, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
